module.exports = __webpack_public_path__ + "static/media/home-logo.1eeb4c3b.svg";